import type { RouteObject } from 'react-router';

import { RomAllRequestsLayout } from './rom/all-requests/RomAllRequestsLayout';
import { romAllRequestsRoutes } from './rom/routes';
import { DefaultErrorElement } from 'src/app/DefaultErrorElement';
import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';
import { BAMBI_API_BASE_URL } from 'src/common/external/bambi-api/constants';
import { tripSubscriptionsRoutes } from 'src/features/trip/trip-subscriptions/routes';
import { TripSubscriptionsLayout } from 'src/features/trip/trip-subscriptions/TripSubscriptionsLayout';

const lazyTripManagement = () =>
  import('./management/TripManagementRoute').then((m) => ({
    Component: m.TripManagementRoute,
  }));

const lazyTripSummary = () =>
  import('./summary/TripSummaryRoute').then((m) => ({
    Component: m.TripSummaryRoute,
  }));

export type TripSummaryRouteParams = {
  tripId: string;
};

export const tripRoutes: RouteObject[] = [
  {
    index: true,
    lazy: lazyTripManagement,
  },
  {
    path: 'test-request-form',
    element: <TripRequestFormTestRoute />,
  },
  {
    path: ':tripId/summary',
    lazy: lazyTripSummary,
  },
  {
    path: 'subscriptions/*',
    Component: TripSubscriptionsLayout,
    children: tripSubscriptionsRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: 'requests/*',
    Component: RomAllRequestsLayout,
    children: romAllRequestsRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: 'route-templates/*',
    lazy: () =>
      import('./routeTemplates/RouteTemplateRoute').then((m) => ({
        Component: m.RouteTemplateRoute,
      })),
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/trips" linkText="Go back to trips" />
    ),
  },
];

export const rideOrderingPortalTripRoutes: RouteObject[] = [
  {
    index: true,
    lazy: lazyTripManagement,
  },
  {
    path: ':tripId/summary',
    lazy: lazyTripSummary,
  },
  {
    path: '*',
    element: <NotFoundChildRoute />,
  },
];

function TripRequestFormTestRoute() {
  return (
    <iframe
      title="Trip Request Form"
      src={`${BAMBI_API_BASE_URL}public/trips/embed/trip-request/?access_token=test123`}
      // Overlay entire screen or they can give it a relatively positioned parent
      style={{
        position: 'absolute',
        // 4rem is the height of our header
        top: '4rem',
        left: 0,
        bottom: 0,
        right: 0,
        width: '100%',
        height: '100%',
        zIndex: 1000,
      }}
    />
  );
}
